import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import LeadForm from "@/pages/submit/components/LeadForm";
import { processSteps } from "@/mocks/stats";

export default function Submit() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "提供线索 - 爆料51",
      url: "https://kunkunedu.cn/submit",
      description: "通过爆料51 征集入口提交你掌握的公众线索，支持匿名提交，核实团队将在 48 小时内初步评估。",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://kunkunedu.cn/" },
        { "@type": "ListItem", position: 2, name: "提供线索", item: "https://kunkunedu.cn/submit" },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="提供线索 | 爆料51 线索提交入口"
        description="通过爆料51 征集入口提交你掌握的公众线索，支持匿名提交。请尽量说明时间、地点、涉及对象，核实团队将在 48 小时内初步评估。"
        keywords="爆料51提供线索,线索提交,我要爆料,悬赏线索入口"
        path="/submit"
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="提交入口"
        title="提供线索，从这一条开始"
        description="你不需要准备完整的证据链，只需把掌握的信息说清楚。剩下的核实工作，交给我们的团队往下追。"
        crumbs={[{ label: "提供线索" }]}
      />

      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="mb-5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">填写线索信息</h2>
              <LeadForm />
            </Reveal>
          </div>

          <aside className="lg:col-span-5">
            <Reveal delay={100}>
              <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <h2 className="font-heading text-base font-bold text-foreground-950">提交之后会发生什么</h2>
                <ol className="mt-5 flex flex-col gap-5">
                  {processSteps.map((step, index) => (
                    <li key={step.step} className="flex gap-3">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-50 font-heading text-sm font-bold text-primary-600">
                        {index + 1}
                      </span>
                      <div>
                        <p className="font-heading text-sm font-bold text-foreground-950">{step.title}</p>
                        <p className="mt-1 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>
            </Reveal>

            <Reveal delay={160}>
              <div className="mt-5 rounded-lg border border-secondary-200 bg-secondary-50 p-5 md:p-6">
                <h2 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900">
                  <i className="ri-shield-keyhole-line" />
                  你的信息如何被保护
                </h2>
                <ul className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-secondary-800">
                  <li className="flex items-start gap-2">
                    <i className="ri-lock-line mt-0.5" />
                    联系方式默认脱敏，不对外公开
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-user-settings-line mt-0.5" />
                    仅核实人员按权限访问原始信息
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-file-shield-2-line mt-0.5" />
                    支持匿名提交，可用代号沟通
                  </li>
                </ul>
                <p className="mt-4 flex items-center gap-2 border-t border-secondary-200 pt-4 text-sm text-secondary-900">
                  <i className="ri-mail-line" />
                  或发送邮件至 tips@baoliao51.com
                </p>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </>
  );
}